import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import { useInventoryBatchListAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryBatchListAPI";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect } from "react";

const BatchListComponent = () => {
  const { NO_PWL_RESULTS } = useImageConstants();
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("INVENTORY", "id");
  const { routeState } = useRouteInfo(routeId);

  const { batchList } = routeState.state as IInventoryState;

  const fetchBatchListAPI = useInventoryBatchListAPI();

  const isBatchingListLoading = useLoader("isBatchingListLoadingInProgress");

  useEffect(() => {
    fetchBatchListAPI();
  }, []);

  return (
    <div className="mt-8 flow-root bg-white h-screen">
      {isBatchingListLoading ? (
        <TableSkeleton />
      ) : batchList?.length === 0 ? (
        <NoDataFoundComponent
          imageURL={NO_PWL_RESULTS}
          message="No Batch Listed"
          description="No Batch  Listed, please onboard some service."
        />
      ) : (
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ">
                      SN
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Name
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Parameters
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {batchList?.map((value, idx) => (
                    <tr key={value?.batch_group_name}>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900  ">{idx + 1}</td>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 ">
                        {value?.batch_group_name}
                      </td>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 ">
                        <span className="py-1 text-left">
                          {value?.batching_attributes ? (
                            <>
                              {value.batching_attributes.mrp && <span>MRP</span>}
                              {value.batching_attributes.expiry_date && (
                                <span>
                                  {value.batching_attributes.mrp && ", "}
                                  Exp Date
                                </span>
                              )}
                              {value.batching_attributes.manufacturing_date && (
                                <span>
                                  {(value.batching_attributes.mrp || value.batching_attributes.expiry_date) && ", "}
                                  Manufacturing Date
                                </span>
                              )}
                              {value.batching_attributes.lot_number && (
                                <span>
                                  {(value.batching_attributes.mrp ||
                                    value.batching_attributes.expiry_date ||
                                    value.batching_attributes.manufacturing_date) &&
                                    ", "}
                                  Lot Number
                                </span>
                              )}
                            </>
                          ) : (
                            <span>NA</span>
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default BatchListComponent;
